import { Temporal } from 'temporal-polyfill';
import type { z } from 'zod';
import { useClock } from '@/lib/clock';

type ParsedCalendarDate = Temporal.PlainDate & z.$brand;
type ParsedInstant = Temporal.Instant & z.$brand;
type Formattable = ParsedCalendarDate | ParsedInstant;

const dayOnly: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
};

export function formatDate(
  value: Formattable,
  { timeZone, locale }: { timeZone: string; locale: string },
): string {
  return value instanceof Temporal.Instant
    ? value.toLocaleString(locale, { ...dayOnly, timeZone })
    : value.toLocaleString(locale, dayOnly);
}

export function DateText({ value }: { value: Formattable }) {
  const clock = useClock();

  return (
    <time dateTime={value.toString()}>
      {formatDate(value, {
        timeZone: clock.timeZone(),
        locale: navigator.language,
      })}
    </time>
  );
}
